/**
 * SYM-6195. What changes on a slide when its picture is swapped.
 *
 * Cropping keeps two things on the slide: the rectangle the customer dragged
 * (`imageCrop`) and a cut-out copy of the photograph made from it
 * (`croppedPreviewUrl`). Everywhere the wizard draws a slide it prefers the
 * cut-out, because that is the only thing that shows the crop without
 * re-implementing it:
 *
 *   src={scene.croppedPreviewUrl || scene.imageUrl}
 *
 * So the cut-out has to die with the picture it was cut from. Clearing only
 * the rectangle leaves the old photograph on screen for good, while the
 * preview and the render show the new one -- the wizard then says two
 * different things at once, and the half the customer works in is the wrong
 * one.
 */

import { CustomerResource } from 'types/apiTypes';

import { VideoScene } from './types';

/**
 * The fields to write on a slide when the customer picks a different picture
 * for it. Both remembered pieces of the old crop go, since neither describes
 * the new photograph.
 */
export function pictureSwapUpdates(
  resource: CustomerResource
): Partial<VideoScene> {
  return {
    imageUrl: resource.path,
    resourceId: resource.id,
    imageCrop: null,
    croppedPreviewUrl: null,
  };
}
